<template>
    <div>
        <div class="modal hide fade" id="modalSummaryCost" tabindex="-1" role="dialog" aria-labelledby="modalSummaryCost" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Inventory Begin {{ processDate }} {{ process_date }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="process_date" class="col-form-label">Process Date:</label>
                                <datetime v-model="process_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                            </div>
                            <div class="form-group">
                                <label for="company_no" class="col-form-label">Company:</label>
                                <select v-model="company_no" class="form-control">
                                    <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-hard-primary" @click="process" data-dismiss="modal">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductSummaryCostModal',
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    })
  },
  props: ['processDate'],
  data () {
    return {
      process_date: null,
      company_no: null
    }
  },
  methods: {
    process () {
      var obj = {
        process_date: this.process_date,
        company_no: this.company_no
      }
      this.$emit('processInventory', obj)
    }
  },
  watch: {
    processDate: {
      immediate: true,
      handler (newValue) {
        this.process_date = newValue
      }
    }
  }
}
</script>
